import React from "react";
import { Link } from "react-router-dom";
import "./LegalContent.styles.css";
import { Helmet } from "react-helmet";

const TncPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cm-legal-content-container">
      <Helmet>
        <title>Globalskyfare | T&C</title>
      </Helmet>
      <div className="inner-banner">
        <h2 className="cm-section-h cm-txt-center cm-white-col">Terms and Conditions</h2>
      </div>
      <div className="cm-section cm-page-center cm-lr-pad pb-10">
        <div>
          <h2>Welcome to <strong>Globalskyfare.com</strong>!</h2>
          <p>The guidelines for using the <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a> website are described in these terms and conditions.</p>
          <p>We presume that you agree to these terms and conditions when using this website. If you disagree with any of the terms and conditions listed here, discontinue using <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a>.</p>
          <p>
            These Terms and Conditions, the Privacy Statement, the Disclaimer Notice, and any Agreements are all referred to by the following terms.
          </p>
          <p>"Client," "You," and "Your" refer to you, the individual who has logged on to this website and complies with the terms and conditions of the company.</p>
          <p>
            The following terms are used to describe our company: "The Company," "Ourselves," "We," "Our," and "Us."
          </p>
          <p>"Party," "Parties," or "Us" might be used to describe the client or ourselves.</p>
          <p>In accordance with and subject to the applicable laws of the United States of America (USA), all terms refer to the offer, acceptance, and consideration of the payment required to carry out the process of our assistance to the Client in the most suitable manner for the specific purpose of meeting the Client's needs with regard to the provision of the Company's stated services.</p>

          <p>Any usage of the terms above or other words in the singular, plural, capitalization, he/she, or they are interpreted as referring to the same thing.</p>
        </div>
        <div>
          <h3><strong>Cookies</strong></h3>
          <p>Cookies are utilized by us. You accepted the usage of cookies in accordance with GlobalSkyFare.com's privacy policy by using the website.</p>
          <p>Cookies are used by the majority of interactive websites to retrieve user information each time a user visits. To make it simpler for users to navigate our website, we employ cookies to make some sections effective. Cookies may also be used by some of our affiliate and advertising partners.</p>
        </div>
        <div>
          <h3><strong>License</strong></h3>
          <p>The intellectual property rights to all content on <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a> are owned by GlobalSkyFare.com and/or its licensees unless otherwise indicated.</p>
          <p>The rights of every intellectual property are reserved. Under the limitations outlined in these terms and conditions, you can use information from <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a> for your personal use.</p>
          <p>You must not:</p>
          <ul>
            <li>Republish material from <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a></li>
            <li>Sell, rent, or sub-license material from <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a></li>
            <li>Reproduce, duplicate, or copy material from <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a></li>
            <li>
              Redistribute content from <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a>
            </li>
          </ul>


          <p>This website has sections that allow users to submit and share information and ideas. Comments are not filtered, edited, published, or reviewed by <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a> before they appear on the website.</p>
          <p>
            The comments do not represent the thoughts and viewpoints of <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a>, its agents, and/or affiliates.
          </p>
          <p>The ideas and viewpoints expressed in the comments are those of the person who posted them. <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a> disclaims all liability for the Comments and any costs, damages, or liabilities resulting from the use, publication, or display of the Comments on this website to the degree allowed by applicable laws.</p>

          <p><a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a> has the right to monitor all comments and to delete those that violate our terms and conditions or are deemed offensive or inappropriate.</p>
          <p>You warrant and represent that:</p>
          <ul>
            <li>You possess all the required permissions and licenses to leave comments on our website;</li>
            <li>The remarks do not infringe upon any third-party's copyright, patent, or trademark, among other intellectual property rights;</li>
            <li>There are no offensive, libelous, defamatory, indecent, or otherwise illegal materials in the Comments that might violate someone's privacy;</li>
            <li>The comments won't be used to advertise, solicit, or promote customs, business, or illegal actions;</li>
          </ul>
          <p>By submitting your comments, you give <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a> a non-exclusive right to use, reproduce, alter, and let others do the same in any manner or media.</p>
        </div>
        <div>
          <h3><strong>Hyperlinking To Our Content</strong></h3>
          <p>Without previous written consent, the following organizations are permitted to link to our website:</p>
          <ul>
            <li>Government agencies;</li>
            <li>Search engines;</li>
            <li>News organizations;</li>
            <li>Distributors of online directories are permitted to connect to our website in the same way that they link to the websites of other companies that are listed and</li>
            <li>System-wide Accredited Businesses, with the exception of charity shopping centers, non-profit organizations, and fundraising organizations that might not link to our website.</li>
          </ul>
          <p>
            These organizations may provide links to publications, our home page, or other content on our website, provided that the link:
          </p>
          <ul>
            <li>(a) is not in any way deceptive;</li>
            <li>(b) does not falsely imply sponsorship, endorsement, or approval of the linking party and its products and/or services; and</li>
            <li>(c) fits within the context of the linking party's site</li>
          </ul>
          <p>The following categories of organizations may submit additional link requests for consideration and approval:</p>
          <ul>
            <li>commonly-known consumer and/or business information sources;</li>
            <li>dot.com community sites;</li>
            <li>associations or other groups representing charities;</li>
            <li>online directory distributors;</li>
            <li>internet portals;</li>
            <li>accounting, law, and consulting firms; and</li>
            <li>educational institutions and trade associations.</li>
          </ul>
          <p>If we determine that: (a) the link would not reflect poorly on us or our accredited businesses; (b) the organization has no negative records with us; (c) the benefit of the hyperlink's visibility to us outweighs the loss of <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a>, and (d) the link is in the context of general resource information, we will grant link requests from these organizations.</p>
          <p>
            The following conditions must be met for these organizations to link to our home page: (a) the link must not be misleading in any manner; (b) it must not falsely suggest sponsorship, support, or approval of the linking party and its goods or services; and (c) it must be appropriate for the context of the linking party's website.
          </p>
          <p>
            If you are one of the organizations mentioned above and want to link to our website, you must notify us by sending an email to <a href="mailto:info@globalskyfare.com"><strong>info@globalskyfare.com</strong></a>.
          </p>
          <p>Kindly include your name, the name of your organization, your contact details, the URL of your website, a list of any URLs you plan to link to from our website, and a list of URLs on our website that you would want to link to. Await an answer for two to three weeks.</p>
          <p>The following is how authorized organizations can link to our website:</p>
          <ul>
            <li>By use of our corporate name or</li>
            <li>By use of the uniform resource locator being linked to; or</li>
            <li>We can use any further description of our website that fits the structure and context of the material on the website of the linking party.</li>
          </ul>
          <p>Without a trademark license agreement, GlobalSkyFare.com's logo or other artwork cannot be used for linking.</p>
        </div>
        <div>
          <h3><strong>iFrames</strong></h3>
          <p>You are not permitted to build frames around our web pages that change the visual presentation or look of our website in any manner without our prior written consent.</p>
        </div>
        <div>
          <h3><strong>Content Liability</strong></h3>
          <p>Any content that appears on your website is not our responsibility.</p>
          <p>
            You pledge to defend and shield us from any accusations made on your website.
          </p>
          <p>Any website seen as libelous, pornographic, or illegal or that violates, infringes upon, or encourages the violation of any third party's rights should not have any links.</p>
        </div>
        <div>
          <h3><strong>Your Privacy</strong></h3><p>Please read Privacy Policy</p>
        </div>
        <div>

          <h3><strong>Reservation of Rights</strong></h3>
          <p>We retain the right to ask that you remove any or all of the links that lead to our website.</p>
          <p>You promise to immediately take down all connections to our website if we ask you to.</p>
          <p>Additionally, we have the right at any moment to change these terms and conditions and the linking policy.</p>
          <p>You accept and agree to be bound by these linking terms and conditions if you consistently link to our website.</p>
        </div>

        <div>
          <h3><strong>Removal of links from our Website</strong></h3>
          <p>You are welcome to contact us anytime by email at <a href="mailto:info@globalskyfare.com"><strong>info@globalskyfare.com</strong></a> if you discover any objectionable links on our website. Although we are not required to do so or to reply to you personally, we will consider requests to remove links.</p>
          <p>We do not guarantee the accuracy, completeness, or correctness of the information on this website, nor do we ensure that the website will continue to be accessible or that the content will be maintained current.</p>
        </div>
        <div>
          <h3><strong>Disclaimer</strong></h3>
          <p>We disclaim any claims, warranties, and conditions pertaining to this website and its use to the greatest degree allowed by applicable law. Nothing in this disclaimer will:</p>
          <ul>
            <li>limit or exclude our or your liability for death or personal injury;</li>
            <li>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
            <li>limit any of our or your liabilities in any way that is not permitted under applicable law or</li>
            <li>exclude any of our or your liabilities that may not be excluded under applicable law.</li>
          </ul>
          <p>Liability restrictions and prohibitions outlined in this section and other places in this disclaimer (a) are governed by the paragraph above and (b) apply to all liabilities emerging under the disclaimer, including those deriving from contracts, torts, and violations of statutory duties.</p>
          <p>We shall not be responsible for any loss or harm as long as the website, content, and services are offered without charge.</p>
        </div>
      </div>
    </div>
  );
};

export default TncPage;
